import EmailRowsPage from '@/modules/email-saved-rows/pages/EmailRowsPage.vue'
import EmailRowsSavedListPage from '@/modules/email-saved-rows/pages/EmailRowsSavedListPage.vue'
import EmailRowsSyncedListPage from '@/modules/email-saved-rows/pages/EmailRowsSyncedListPage.vue'
import EmailSavedRowsDetails from '@/modules/email-saved-rows/pages/EmailSyncedRowDetailsPage.vue'
import EmailSavedRowsForm from '@/modules/email-saved-rows/pages/EmailSavedRowsFormPage'

export default [
  {
    path: '/content/email-rows',
    component: EmailRowsPage,
    children: [
      {
        name: 'EmailRowsSaved',
        path: 'saved',
        component: EmailRowsSavedListPage,
        meta: {
          auth: ['EmailSavedRows::Read'],
          title: 'EmailRows_Route_SavedListTitle'
        }
      },
      {
        name: 'EmailRowsSynced',
        path: 'synced',
        component: EmailRowsSyncedListPage,
        meta: {
          auth: ['EmailSavedRows::Read'],
          title: 'EmailRows_Route_SyncedListTitle'
        }
      }
    ]
  },
  {
    name: 'EmailSavedRowsUpdate',
    path: '/content/email-saved-rows/update',
    component: EmailSavedRowsForm,
    meta: {
      auth: ['EmailSavedRows::Update'],
      title: 'EmailRows_Route_SavedUpdateTitle'
    }
  },
  {
    name: 'EmailSavedRowsDetails',
    path: '/content/email-rows/synced-details',
    component: EmailSavedRowsDetails,
    meta: {
      auth: ['EmailSavedRows::Read'],
      title: 'EmailRows_Route_SyncedDetailsTitle'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/email-saved-rows/router/index.js